import http from './http'
import type { InvoiceAddress, InvoiceAddressPayload } from '@/types/api'

export const addressService = {
  async list(): Promise<InvoiceAddress[]> {
    const { data } = await http.get<InvoiceAddress[]>('/user/addresses')
    return data
  },

  async save(payload: InvoiceAddressPayload): Promise<InvoiceAddress> {
    const { data } = await http.post<InvoiceAddress>('/user/addresses', payload)
    return data
  },

  async remove(id: string): Promise<void> {
    await http.delete(`/user/addresses/${id}`)
  },
}
